import React, { FC } from "react"
import { RoundedRectangle } from "../atoms/roundedrectangle/RoundedRectangle"
import { Spacer } from "../atoms/Atoms"
import { BodyLarge, BodySmall } from "../atoms/Bodies"
import { Button } from "../atoms/buttons/Button"
import L10n from "lib/carrot-l10n"
import { RRButtonFooter } from "../atoms/roundedrectangle/RRButtonFooter"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

type BenefitEnrollmentModuleProps = {
  onClickEnroll: () => void
}

const BenefitEnrollmentModule: FC<BenefitEnrollmentModuleProps> = ({ onClickEnroll }) => (
  <RoundedRectangle backgroundColor="mint-alternate">
    <BodyLarge color="black-80">{l`benefitEnrollment.enrollInYourFinancialBenefit`}</BodyLarge>
    <Spacer height={1} />
    <BodySmall color="black-80">{l`benefitEnrollment.shareSomeInfo`}</BodySmall>
    <RRButtonFooter onClick={onClickEnroll} outline>
      {l`benefitEnrollment.enroll`}
    </RRButtonFooter>
  </RoundedRectangle>
)

export { BenefitEnrollmentModule }
